import React from 'react';
export default function Footer(){
    return(
        <footer>Made with ❤️ by <a href="github.com/sheldor07">Yajat Gulati</a></footer>
    )
}